<div class="card mb-3">
  <div class="card-header d-flex">
    <div class="p-2">
      <h4><i class="fas fa-server"></i> Configuration Email </h4>
    </div>
    <div class="ml-auto p-2">
      <ng-template ngxPermissionsOnly="SETTING:MAIL:AGENCY">
        <button (click)="editConfig(true)" *ngIf="!edit" type="button" class="btn btn-icon btn-primary ml-1"
          ngbTooltip="Modifier">
          <i class="feather icon-edit-2"></i>
        </button>
      </ng-template>
      <ng-template ngxPermissionsOnly="SETTING:MAIL:AGENCY">
        <button (click)="editConfig(false)" *ngIf="edit" type="button" class="btn btn-icon btn-danger ml-1"
          ngbTooltip="Fermer">
          <i class="feather icon-x-circle"></i>
        </button>
      </ng-template>
    </div>
  </div>
  <div class="card-body p-3">
    <div class="col-md-12">
      <div class="row"><span class="badge badge-primary my-2 f-14 width">{{title}}</span></div>
    </div>
    <div class="col-md alert alert-info alert show" role="alert">
      <i class="fa fa-info-circle fa-lg"></i>
      <span class="mb-0 text-muted ml-3">
        <strong>Configurez votre fournisseur d'email pour l'envoi des notifications.</strong>
      </span>
    </div>

    <form [formGroup]="form" (ngSubmit)="onSubmit()">
      <div class="modal-body">
        <div class="col-md-12">
          <div class="form-group">
            <div class="row mb-2">
              <!-- Provider -->
              <div class="col-md-6 mb-3">
                <label for="provider">Fournisseur <span class="text-danger">*</span></label>
                <select [attr.disabled]="!edit ? '' : null" class="form-control" id="provider"
                  formControlName="provider" (change)="onProviderChange()">
                  <option *ngFor="let p of providers" [value]="p.value">{{p.label}}</option>
                </select>
              </div>

              <!-- Active -->
              <div class="col-md-6 mb-3">
                <label for="active">Statut</label>
                <div class="custom-control custom-switch mt-2">
                  <input [attr.disabled]="!edit ? '' : null" type="checkbox" class="custom-control-input"
                    id="active" formControlName="active">
                  <label class="custom-control-label" for="active">
                    {{f.active.value ? 'Active' : 'Inactive'}}
                  </label>
                </div>
              </div>

              <!-- SMTP Fields -->
              <ng-container *ngIf="showSmtpFields">
                <div class="col-md-6 mb-3">
                  <label for="host">Serveur SMTP <span class="text-danger">*</span></label>
                  <input [attr.disabled]="!edit ? '' : null" type="text" class="form-control" id="host"
                    formControlName="host" placeholder="smtp.example.com">
                </div>
                <div class="col-md-3 mb-3">
                  <label for="port">Port</label>
                  <select [attr.disabled]="!edit ? '' : null" class="form-control" id="port" formControlName="port">
                    <option [ngValue]="25">25</option>
                    <option [ngValue]="465">465</option>
                    <option [ngValue]="587">587</option>
                    <option [ngValue]="2525">2525</option>
                  </select>
                </div>
                <div class="col-md-3 mb-3">
                  <label for="encryption">Chiffrement</label>
                  <select [attr.disabled]="!edit ? '' : null" class="form-control" id="encryption"
                    formControlName="encryption">
                    <option *ngFor="let e of encryptions" [value]="e.value">{{e.label}}</option>
                  </select>
                </div>
              </ng-container>

              <!-- Username (SMTP + BREVO) -->
              <div class="col-md-6 mb-3" *ngIf="showUsernameField">
                <label for="username">Nom d'utilisateur</label>
                <input [attr.disabled]="!edit ? '' : null" type="text" class="form-control" id="username"
                  formControlName="username" placeholder="Nom d'utilisateur SMTP">
              </div>

              <!-- Password (SMTP only) -->
              <div class="col-md-6 mb-3" *ngIf="showSmtpFields">
                <label for="password">Mot de passe</label>
                <input [attr.disabled]="!edit ? '' : null" type="password" class="form-control" id="password"
                  formControlName="password" placeholder="Mot de passe SMTP">
              </div>

              <!-- API Key (RESEND, MAILJET, SENDGRID, BREVO) -->
              <div class="col-md-6 mb-3" *ngIf="showApiKeyField">
                <label for="apiKey">Cle API <span class="text-danger">*</span></label>
                <input [attr.disabled]="!edit ? '' : null" type="password" class="form-control" id="apiKey"
                  formControlName="apiKey" placeholder="Cle API">
              </div>

              <!-- API Secret (MAILJET only) -->
              <div class="col-md-6 mb-3" *ngIf="showApiSecretField">
                <label for="apiSecret">Secret API <span class="text-danger">*</span></label>
                <input [attr.disabled]="!edit ? '' : null" type="password" class="form-control" id="apiSecret"
                  formControlName="apiSecret" placeholder="Secret API Mailjet">
              </div>

              <!-- AWS SES Fields -->
              <ng-container *ngIf="showAwsFields">
                <div class="col-md-6 mb-3">
                  <label for="accessKey">Access Key <span class="text-danger">*</span></label>
                  <input [attr.disabled]="!edit ? '' : null" type="password" class="form-control" id="accessKey"
                    formControlName="accessKey" placeholder="AWS Access Key">
                </div>
                <div class="col-md-6 mb-3">
                  <label for="secretKey">Secret Key <span class="text-danger">*</span></label>
                  <input [attr.disabled]="!edit ? '' : null" type="password" class="form-control" id="secretKey"
                    formControlName="secretKey" placeholder="AWS Secret Key">
                </div>
                <div class="col-md-6 mb-3">
                  <label for="region">Region AWS</label>
                  <input [attr.disabled]="!edit ? '' : null" type="text" class="form-control" id="region"
                    formControlName="region" placeholder="us-east-1">
                </div>
              </ng-container>

              <!-- Champs communs -->
              <div class="col-md-12 mt-3 mb-2">
                <span class="badge badge-secondary f-14 width">Expediteur</span>
              </div>

              <div class="col-md-6 mb-3">
                <label for="senderEmail">Email expediteur <span class="text-danger">*</span></label>
                <input [attr.disabled]="!edit ? '' : null" type="email" class="form-control" id="senderEmail"
                  formControlName="senderEmail" placeholder="noreply@votredomaine.com"
                  [ngClass]="{'is-invalid': submit && f.senderEmail.invalid}">
                <div class="invalid-feedback" *ngIf="submit && f.senderEmail.invalid">
                  <div>L'email expediteur est requis et doit etre valide.</div>
                </div>
              </div>

              <div class="col-md-6 mb-3">
                <label for="senderName">Nom expediteur</label>
                <input [attr.disabled]="!edit ? '' : null" type="text" class="form-control" id="senderName"
                  formControlName="senderName" placeholder="Mon Agence">
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="modal-footer" *ngIf="edit">
        <button *ngxPermissionsOnly="'SETTING:MAIL:AGENCY'" type="button" class="btn btn-info mr-2"
          (click)="onTest()" [disabled]="testing">
          <i class="fas fa-paper-plane"></i>
          {{testing ? 'Test en cours...' : 'Tester la connexion'}}
        </button>
        <button *ngxPermissionsOnly="'SETTING:MAIL:AGENCY'" type="submit" class="btn btn-primary"
          [disabled]="submit">
          Enregistrer <i class="feather icon-save"></i>
        </button>
      </div>
    </form>
  </div>
</div>
